import { Avatar, Box, Card, CardActions, CardContent, CardHeader, Dialog, Stack, Typography } from '@mui/material'
import { DateTime } from 'luxon'
import React, { MouseEventHandler } from 'react'
import { BiDownload, BiQuestionMark, BiX } from 'react-icons/bi'
import ImageGallery, { ReactImageGalleryItem } from 'react-image-gallery'

import { getVehicleCategoryIcon } from 'src/commons/constants'
import BaseIconButton from 'src/muiv5/components/commons/BaseIconButton'
import Tag from 'src/muiv5/components/commons/Tag'

import './styles.css'
import { renderItem } from './utils'

export interface ISmartPatrolImagesDialogProps {
  agentName?: string
  comment?: string
  date?: string
  downloadLink?: string
  downloadUrl?: string
  images: ReactImageGalleryItem[]
  onCloseClick?: MouseEventHandler<HTMLButtonElement>
  onDownloadClick?: MouseEventHandler<HTMLButtonElement>
  type?: string
  vehicleType?: string
}

export default function SmartPatrolImagesDialog({
  agentName,
  type,
  vehicleType,
  date,
  images,
  downloadUrl,
  comment,
  onCloseClick,
  onDownloadClick,
}: ISmartPatrolImagesDialogProps) {
  const VehicleTypeIcon = vehicleType ? getVehicleCategoryIcon(vehicleType) : BiQuestionMark

  return (
    <Dialog maxWidth="md" scroll="paper" open>
      <Card
        sx={{
          minWidth: '500px',
        }}
      >
        <CardHeader
          avatar={
            <Avatar sx={{ color: 'white', fontSize: '20px' }}>
              <VehicleTypeIcon />
            </Avatar>
          }
          action={
            <Stack direction="row" gap={1}>
              <BaseIconButton disabled={!downloadUrl} onClick={onDownloadClick}>
                <BiDownload />
              </BaseIconButton>
              <BaseIconButton onClick={onCloseClick}>
                <BiX />
              </BaseIconButton>
            </Stack>
          }
          title={<Typography variant="h6">{agentName}</Typography>}
          subheader={
            <Stack direction="column" gap={2} alignItems="flex-start">
              <Typography variant="subtitle1">
                {date ? DateTime.fromISO(date).toLocaleString(DateTime.DATETIME_SHORT) : ''}
              </Typography>
              <Tag label={type} />
            </Stack>
          }
        />
        <CardContent>
          <Box sx={{ py: 2 }}>
            <Typography variant="h6">{comment}</Typography>
          </Box>
          <Box display="flex" alignItems="center" justifyContent="center" minWidth="300px" minHeight="300px">
            <ImageGallery
              showNav={false}
              showFullscreenButton={false}
              useTranslate3D={false}
              showPlayButton={false}
              showIndex={false}
              showBullets
              items={images}
              lazyLoad={false}
              thumbnailPosition="right"
              renderItem={renderItem}
            />
          </Box>
        </CardContent>
        <CardActions disableSpacing />
      </Card>
    </Dialog>
  )
}
